import React from 'react';
import { CameraIcon } from 'lucide-react';
import { profile } from '../../data/profil';
const fieldClass = 'w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-[15px] text-ville-navy placeholder:text-slate-400 transition-colors duration-150 ease-ville focus:border-ville-indigo focus:outline-none focus:ring-2 focus:ring-ville-indigo/20';
const labelClass = 'block text-sm font-semibold text-slate-600';
interface FieldProps {
  id: string;
  label: string;
  type?: string;
  defaultValue?: string;
  placeholder?: string;
}
function Field({
  id,
  label,
  type = 'text',
  defaultValue,
  placeholder
}: FieldProps) {
  return <div data-id="element-1787" data-mp="3baeoojcgvaqe">
      <label htmlFor={id} className={labelClass} data-id="element-1788" data-mp="3baok4mga6a3h">
        {label}
      </label>
      <input id={id} type={type} defaultValue={defaultValue} placeholder={placeholder} className={`mt-1.5 ${fieldClass}`} data-id="element-1789" data-mp="3g8py4syunj83" />
    </div>;
}
export function PersonalInfo() {
  return <section aria-labelledby="personal-info-title" className="rounded-3xl border border-slate-200 bg-white p-6 sm:p-8" data-id="element-1790" data-mp="24sroamvukt5t">
      <h2 id="personal-info-title" className="text-xl font-extrabold tracking-tight text-ville-navy" data-id="element-1791" data-mp="16ggqoqk7bgl5">
        Personal information
      </h2>

      <div className="mt-6 flex flex-wrap items-center gap-5" data-id="element-1792" data-mp="1kgrh5shlmt5s">
        <span className="grid h-20 w-20 place-items-center rounded-full bg-ville-indigo-soft text-xl font-bold text-ville-indigo" aria-hidden="true" data-id="element-1793" data-mp="1fh587v8szz2s">
          {profile.initials}
        </span>
        <div data-id="element-1794" data-mp="1pe0406dozldd">
          <button type="button" className="inline-flex items-center gap-2 rounded-full border border-slate-200 px-4 py-2 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1795" data-mp="1pe9qvl3fxceu">
            <CameraIcon className="h-4 w-4" aria-hidden="true" data-id="element-1796" data-mp="285swlzoun4kk" />
            Change my photo
          </button>
          <p className="mt-2 text-xs text-slate-500" data-id="element-1797" data-mp="15so8evmaoxbp">JPG or PNG, 5 MB maximum.</p>
        </div>
      </div>

      <form className="mt-8 grid gap-5 sm:grid-cols-2" onSubmit={event => event.preventDefault()} data-id="element-1798" data-mp="19syiokh4e9wd">
        <Field id="prenom" label="First name" defaultValue={profile.firstName} data-id="element-1799" data-mp="1errv09ko7uuy" />
        <Field id="nom" label="Last name" defaultValue={profile.lastName} data-id="element-1800" data-mp="1jk2vbdjbpio1" />
        <Field id="naissance" label="Date of birth" type="date" defaultValue={profile.birthDate} data-id="element-1801" data-mp="1jldv729ne69v" />
        <Field id="courriel" label="Email" type="email" defaultValue={profile.email} data-id="element-1802" data-mp="1okyzztbi18ui" />
        <Field id="tel" label="Primary phone" type="tel" defaultValue={profile.phone} data-id="element-1803" data-mp="1tjtp1d027tn2" />
        <Field id="tel-secondaire" label="Secondary phone" type="tel" placeholder="Optional" defaultValue={profile.phoneSecondary} data-id="element-1804" data-mp="1xk3soj0dq7yr" />
        <Field id="cellulaire" label="Mobile phone" type="tel" defaultValue={profile.mobile} data-id="element-1805" data-mp="36ukqvnheuim" />
      </form>
    </section>;
}